export const TOURNAMENTS = '/tournaments';
export const ADMIN = '/admin';
export const MANAGE_ADMINS = '/manage-admins';
export const HOME = '/';
export const PRIVACY ="/privacy";
export const TOURNAMENT_VIEW = ADMIN;  
export const REGISTER = '/register';
export const STATS = '/stats';
export const BASIC_SETTING = '/basic-settings';
export const FORM_SETTINGS = '/forms';
export const ENTER_RESULTS = '/enter-results';
export const MANAGE_TEAMS = '/teams';
export const MANAGE_POST = '/post';
export const POINTS_TABLE_SETTING = '/points-table';
export const VIEW_MATCHES = '/view-matches';